import React from "react";
import { View } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import Skeletons from "../skeleton-components/Skeletons";

const UserBalanceSkeleton: React.FC = () => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();

  return (
    <View
      style={{
        gap:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? 12
            : 30,
        flex:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? 1
            : 0.5,
        width:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? "99%"
            : "auto",
        margin:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? 1
            : 0,
      }}
    >
      {/* Token Balance Section */}
      <View
        style={{
          padding:
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 12
              : 24,
          borderColor: AppColors.gray_828282,
          borderWidth: 1,
          borderRadius: 8,
          backgroundColor: AppColors.black_191919,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Skeletons
            width="150px"
            height={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 18
                : 24
            }
            style={{ borderRadius: 4 }}
          />
          <Skeletons
            width="20px"
            height="20px"
            circle
            style={{ borderRadius: 10 }}
          />
        </View>

        <Skeletons
          width="100%"
          height={1}
          style={{ marginTop: 16, marginBottom: 16, borderRadius: 4 }}
        />

        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <View style={{ flexDirection: "row", gap: 12, alignItems: "center" }}>
            <Skeletons
              width={
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "44px"
                  : "56px"
              }
              height={
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "40px"
                  : "51px"
              }
              style={{ borderRadius: 8 }}
            />
            <Skeletons
              width="60px"
              height={
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 22
                  : 35
              }
              style={{ borderRadius: 4 }}
            />
          </View>
          <Skeletons width="100px" height={40} style={{ borderRadius: 10 }} />
        </View>
      </View>

      {/* Coins Balance Section */}
      <View
        style={{
          padding:
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 12
              : 24,
          borderColor: AppColors.gray_828282,
          borderWidth: 1,
          borderRadius: 8,
          backgroundColor: AppColors.black_191919,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Skeletons
            width="150px"
            height={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 18
                : 24
            }
            style={{ borderRadius: 4 }}
          />
          <Skeletons
            width="20px"
            height="20px"
            circle
            style={{ borderRadius: 10 }}
          />
        </View>

        <Skeletons
          width="100%"
          height={1}
          style={{ marginTop: 16, marginBottom: 16, borderRadius: 4 }}
        />

        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <View style={{ flexDirection: "row", gap: 12, alignItems: "center" }}>
            <Skeletons
              width={
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "44px"
                  : "56px"
              }
              height={
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "40px"
                  : "51px"
              }
              style={{ borderRadius: 8 }}
            />
            <Skeletons
              width="60px"
              height={
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 22
                  : 35
              }
              style={{ borderRadius: 4 }}
            />
          </View>
          <Skeletons width="100px" height={40} style={{ borderRadius: 10 }} />
        </View>
      </View>
    </View>
  );
};

export default UserBalanceSkeleton;

const useStyles = CreateResponsiveStyle(
  {},
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {},
  }
);
